









































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";

@Component({
  components: {},
})
export default class ActivityItemComponent extends Vue {
  @Prop() readonly items!: any;
  @Prop() readonly emptyText!: string;

  toReadableTitle(item) {
    if (item.Section === "Feedback") {
      return `Posted a comment: '${item.Title}'`;
    } else {
      return `${item.Description} ${item.Status}`;
    }
  }

  toLocalDate(value) {
    var date = new Date(value);
    return date.toDateString();
  }
}
